<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">{{ $t(pageTitle) }}</h1>
        <div class="inner d-flex justify-content-end mt-4 mb-4">
          <button
            type="button"
            class="btn btn-success create-btn"
            @click="createModalOpen()"
          >{{ $t("登録") }}</button>
        </div>
        <div class="table-list inner">
          <h2 class="title">{{ $t("検索結果") }}</h2>
          <div class="content">
            <table class="table table-bordered">
              <thead class="thead">
                <tr>
                  <th scope="col">{{ $t("工場名") }}</th>
                  <th width="90" scope="col">{{ $t("コード") }}</th>
                  <th width="90" scope="col">{{ $t("国") }}</th>
                  <th width="90" scope="col">{{ $t("都道府県") }}</th>
                  <th width="160" scope="col">{{ $t("TEL") }}</th>
                  <th width="160" scope="col">{{ $t("FAX") }}</th>
                  <th width="160" scope="col">{{ $t("稼働時刻") }}</th>
                  <th width="110" scope="col"></th>
                  <th width="80" scope="col"></th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-for="(item, index) in mixinGetItems" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td>
                    <template v-for="country in countries">
                      <template v-if="item.countryCode === country.code">
                        {{ $t(country.name) }}
                      </template>
                    </template>
                  </td>
                  <td>{{ $t(getPrefName(item)) }}</td>
                  <td>{{ item.phoneNo }}</td>
                  <td>{{ item.faxNo }}</td>
                  <template v-if="item.isFullWorkTime">
                    <td>{{ $t('24時間稼働') }}</td>
                  </template>
                  <template v-else>
                    <td>{{ item.displayStartTime | mixinViewTimeToHourMinute }}&nbsp;~&nbsp;{{ item.displayEndTime | mixinViewTimeToHourMinute }}</td>
                  </template>
                  <td>
                    <button
                    @click="createModalOpen(item)"
                    type="button" class="btn-light btn">{{ $t("編集") }}</button>
                  </td>
                  <td>
                    <button
                    @click="deleteAlert(item)"
                    type="button" class="btn-danger btn">{{ $t("削除") }}</button>
                  </td>
                </tr>
                <tr v-if="load && !mixinGetItems[0]">
                  <td colspan="9999">
                    <div class="d-flex justify-content-center m-5" v-if="load">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr v-else-if="!load  && !mixinGetItems[0]">
                  <td rowspan="2" colspan="9999" class="text-center">
                    {{ $t('ノーデータメッセージ') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <paginate
          :page-count="mixinGetPageCount"
          :force-page="mixinGetForcePage"
          :page-range="3"
          :margin-pages="1"
          :click-handler="mixinClickCallback"
          :prev-text="'«'"
          :next-text="'»'"
          :container-class="'pagination justify-content-end'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          ref="page"
        ></paginate>
        <create-modal
        ref="createModal"
        @registed="init()"
        @modal-close="init()"
        ></create-modal>
      </div>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'
import countries from '../../assets/json/country.json'
import pref from '../../assets/json/pref.json'
import createModal from './createModal'
export default {
  components: {
    createModal,
  },
  data() {
    return {
      pref: pref,
      list: [],
      countries: countries,
      load: false,
      pageTitle: '工場情報一覧',
    }
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      console.log(err)
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
    await this.init()
  },
  methods: {
    async init() {
      this.mixinCurrentPageClear()
      this.list = []
      this.load = true
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/spaces`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {key: 'site'},
          }
        )
        this.list = res.data
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    },
    createModalOpen(item = {}) {
      this.$refs.createModal.createModalOpen(item)
    },
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(`${item.name}`) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: '',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          await this.$axios.put(
            `${this.$appConfig.CommonApiUrl}/space`,
            { id: item.id, isDelete: true },
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
            }
          )
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
          this.init()
        } catch (err) {
          this.$toasted.show(this.$t('データ削除エラーメッセージ'))
        }
      }
    },
    getPrefName(item) {
      const prefs = this.pref[item.countryCode] || []
      const pref = prefs.find(value => item.prefCode === value.code) || {}
      return pref.name || ''
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style lang="scss" scoped>
</style>
